import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { QcPendingPage } from "@/features/quality/components/pending/qc-pending-page";

const search = z.object({
  // To sample and Completed (2026-10-22): the lab side lives on Sample Allocation's monitor (user,
  // 2026-10-14). An old bookmark to Under test lands on To sample rather than failing.
  tab: z
    .enum(["requested", "completed"])
    .default("requested")
    .catch("requested"),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  // This plant / All my plants, and one truck's lots (QC team, 2026-10-16).
  scope: z.literal("all").optional().catch(undefined),
  truck: z.coerce.number().int().positive().optional().catch(undefined),
  truckLabel: z.string().optional(),
  // The finished tab's page; the live tabs scroll.
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/quality/pending/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.sample_pending"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <QcPendingPage
      search={s}
      onSearch={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, ...next }),
        })
      }
    />
  );
}
